<template>
  <div :class="['divider', `divider-${variant}`, { 'divider-vertical': vertical }]">
    <slot></slot>
  </div>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'light', 'dark', 'primary'].includes(value)
  },
  vertical: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.divider {
  width: 100%;
  height: 1px;
  background: var(--color-border);
  margin: var(--spacing-4) 0;
  border: none;
}

.divider-light {
  background: var(--color-border-light);
}

.divider-dark {
  background: var(--color-border-dark);
}

.divider-primary {
  background: var(--color-primary);
  height: 2px;
}

.divider-vertical {
  width: 1px;
  height: 100%;
  margin: 0 var(--spacing-4);
  display: inline-block;
}

.divider-vertical.divider-primary {
  width: 2px;
}
</style>

